export const GOVT_FORM_SUBMITTING = 'GOVT_FORM_SUBMITTING' as const;
export const GOVT_FORM_SUBMITTED = 'GOVT_FORM_SUBMITTED' as const;
export const GOVT_FORM_FAILED = 'GOVT_FORM_FAILED' as const;
export const GOVT_FORM_RESET = 'GOVT_FORM_RESET' as const;
export const GOVT_UPLOAD_FORM = 'GOVT_UPLOAD_FORM' as const;
